import { ApiClientError, api_client } from "@/api/api_client";

export interface WebBootstrapUser {
  user_id: number;
  username: string;
  is_root?: boolean;
  category: string | null;
  default_lang: string | null;
}

export interface WebBootstrapData {
  user: WebBootstrapUser;
  permissions: string[];
  sql_debug_enabled: boolean;
  allowed_upload_types?: string;
  branding?: {
    company_name: string;
    company_address: string;
  };
  customization: {
    user_mark: string;
  };
}

interface WebBootstrapExtras {
  asset_version: string;
}

export interface WebBootstrapResult {
  data: WebBootstrapData;
  asset_version: string;
}

export async function get_web_bootstrap(): Promise<WebBootstrapResult> {
  const result = await api_client.get<WebBootstrapData, WebBootstrapExtras>(
    "/api/web/bootstrap",
  );

  if (!result.data || !result.extras) {
    throw new ApiClientError("启动响应缺少必要信息", "protocol");
  }

  return {
    data: result.data,
    asset_version: result.extras.asset_version,
  };
}
